import React from 'react';
// Icon
class IconPencil extends React.Component {
  render() {
    return (
      <svg id="IconPencil" className={ this.props.styleName } version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="50 -50 200 200" enableBackground="new 50 -50 200 200" >
      <path d="M220.7-20.7c-15.5-15.6-27.2-13.2-27.2-13.2L76.8,82.7l-10.9,51.3l51.3-10.9L233.9,6.5C233.9,6.5,236.3-5.2,220.7-20.7z
         M114.2,117l-17.5,3.8c-1.7-3.2-3.7-6.3-7.4-10c-3.7-3.7-6.9-5.7-10-7.4L83,85.8l5.1-5.1c0,0,9.5,0.2,20.3,10.9
        c10.8,10.8,11,20.3,11,20.3L114.2,117z"/>
      </svg>
    );
  }
}

export default IconPencil;